import React from 'react';
import { TextVariant } from '@naf/text';
import useSelector from '@redux/typedHooks';
import { formattedPrice } from '@lib/formattedPrice';
import { ProductID } from '@lib/ProductID';
import { ProductTitle } from './ProductTitle';
import { OrderSummary } from './Summary.utils';
import * as S from './Summary.styles';

interface ReceiptSummaryProps {
  orderSummaries: OrderSummary[];
  grandTotal?: number;
}

export const ReceiptSummary = ({ orderSummaries, grandTotal }: ReceiptSummaryProps) => {
  const user = useSelector((state) => state.myMembership.customerInformation.data);
  const isMember = user?.membership?.isValid ?? false;
  const hasPurchasedMembership = orderSummaries.some(
    (productLine) =>
      productLine.productNumber === ProductID.MembershipWithRoadsideAssistance ||
      productLine.productNumber === ProductID.Membership,
  );

  return (
    <S.SummaryWrapper>
      <S.Summary>
        <S.SummaryHeading variant={TextVariant.Header3}>Ditt kjøp</S.SummaryHeading>
        {orderSummaries.map((productLine, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <S.LineGroup key={`${productLine.productNumber}-${index}`}>
            <S.LineWrapper>
              <ProductTitle
                productName={productLine.productName}
                isMember={isMember}
                showNonMemberText={!hasPurchasedMembership}
              />
              <S.Price variant={TextVariant.ArticleTextHeader}>{formattedPrice(productLine.productPrice)} kr</S.Price>
            </S.LineWrapper>
          </S.LineGroup>
        ))}
        {grandTotal && (
          <S.LineWrapper $withTopBorder>
            <S.LineText variant={TextVariant.ArticleTextHeader}>Totalt</S.LineText>
            <S.TotalPrice variant={TextVariant.ArticleTextHeader}>{formattedPrice(grandTotal)} kr</S.TotalPrice>
          </S.LineWrapper>
        )}
        {isMember && <S.LineText variant={TextVariant.Small}>Din medlemspris!</S.LineText>}
      </S.Summary>
    </S.SummaryWrapper>
  );
};
